import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import {withTranslation} from "react-i18next";
import {isElectron} from "react-device-detect";
import apiApp from "../../api/apiApp";
import {pageLoadManageActions as loader} from "../../reducers/load";
import Startup from "../screens/startup/Startup";
import modalManage from "../../reducers/modal-manage";
import lampManage from "../../reducers/lamp-manage";
import {errorApp} from "../../reducers/app";
import {contains} from "../../helpers/functions";
import configApp from "../../config/config";
import store from "../../localStorage";

class StartupContainer extends Component {
    intervalId = ''

    constructor(props) {
        super(props);
        this.state = {
            employees: [],
            render_list_employees: [],
            first_load: true,
            selected_structures: ['All'],
            structures_for_filter: [],
        }
        document.title = props.app.document_title || props.t('Lamp');
    }

    componentDidMount() {
        this.getEmployees()
        .then(() => {
            if (this.props.lamp.view_settings.auto_update) this.intervalId = setInterval(this.getEmployees, 10000);
        })
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    getEmployees = () => {
        return new Promise((resolve, reject) => {
            if (this.state.first_load) loader.start('screen_startup');
            let window_name = '';
            let window = this.props.app.settings.window_name;
            if (isElectron) {
                window_name = configApp.window_name;
            } else {
                window_name = (window === "") ? configApp.window_name : window;
            };
            let data = {
                last_hour: this.props.lamp.view_settings.show_last_hours,
                window_name: window_name,
            };
            apiApp.getEmployeesTakeExam(data)
            .then(response => {
                let employees = this.filterByStructureAndIntervalsAndTerminal(response.data.employees);
                employees = this.sort(employees);
                this.setState({
                    employees: employees,
                    render_list_employees: employees,
                    structures_for_filter: this.setStructuresForFilter(),
                    first_load: false,
                }, () => {
                    let employees = {};
                    response.data.employees.forEach(emp => employees[emp.uuid] = emp);
                    lampManage.saveEmployees(employees);
                    loader.stop('screen_startup');
                    resolve();
                });
            }).catch(e => {
                loader.stop('screen_startup');
                errorApp(store.dispatch, e);
                reject();
            });
        })
    }

    /**
     *
     * @param employees
     * @returns {*}
     */
    sort = (employees) => {
        let sortBy = require('lodash.sortby');
        if (this.props.lamp.view_settings.sort_type === 'descending') {
            return sortBy(employees, this.props.lamp.view_settings.sort_by).reverse();
        } else {
            return sortBy(employees, this.props.lamp.view_settings.sort_by);
        }
    }

    filterByStructureAndIntervalsAndTerminal = (employees) => {
        let structures = this.props.lamp.view_settings.structures,
            employees_filtered = [];
        employees.forEach((emp) => {
            if (contains(structures, +emp.structure_id) && this.intervalFilter(emp) && this.filterByTerminalId(emp)) employees_filtered.push(emp);
        });
        return employees_filtered;
    }

    setStructuresForFilter = () => {
        const structures_array = [];
        const getValue = (arr) => arr.forEach(el => {
            if (this.props.lamp.view_settings.structures.includes(el.value)) structures_array.push(el);
            if (el.children) getValue(el.children);
        });
        getValue(this.props.lamp.structures);
        return structures_array
    };

    setSelectedStructures = (id) => {
        const old_state = this.state.selected_structures;
        let new_state = old_state.includes(id)
            ? old_state.filter(el => el !== id)
            : old_state.filter(el => el !== 'All').concat(id);
        if (new_state.length === 0 || id === 'All') new_state = ['All'];
        this.setState({selected_structures: new_state});
    };

    filterByTerminalId = (emp) => {
        const terminal_id = this.props.lamp.view_settings.terminal_id
        const emp_id = emp.device_id.toString()
        return terminal_id.length === 0 || terminal_id.includes(emp_id)
    }

    intervalFilter = (employee) => {
        let employee_time = new Date(employee.passage_dt).getTime(),
            show_intervals = this.props.lamp.view_settings.show_intervals,
            all_intervals = this.props.lamp.view_settings.intervals.concat(this.props.lamp.view_settings.my_intervals),
            all_intervals_names = [],
            got_in_interval = [];
            all_intervals.forEach(el => all_intervals_names.push(el.name));
        if (show_intervals.length > 0) {
            for (let i = 0; i < show_intervals.length; i++) {
                let interval_name = show_intervals[i];
                for (let i = 0; i < all_intervals.length; i++) {
                    if (all_intervals[i].name === interval_name) {
                        let start_hour = all_intervals[i].start.slice(0, 2),
                            start_minutes = all_intervals[i].start.slice(-2),
                            end_hour = all_intervals[i].end.slice(0, 2),
                            end_minutes = all_intervals[i].end.slice(-2),
                            interval_start = new Date(employee.passage_dt).setHours(start_hour, start_minutes, 0),
                            interval_end = new Date(employee.passage_dt).setHours(end_hour, end_minutes, 0);
                        if (employee_time >= interval_start && employee_time <= interval_end) {
                            got_in_interval.push(true);
                        } else {
                            got_in_interval.push(false);
                        }
                    } else {
                        let res = all_intervals_names.includes(interval_name) ? false : true;
                        got_in_interval.push(res);
                    }
                }
            }
        } else {
            got_in_interval.push(true);
        };

        return got_in_interval.includes(true) ? true : false;
    }

    search = (search_val) => {
        let employees = [];
        if (search_val) {
            this.state.employees.find((o, i) => {
                if (o.title.toLowerCase().indexOf(search_val.toLowerCase()) >= 0 || o.number.indexOf(search_val) >= 0) employees.push(o);
            });
        } else {
            employees = this.state.employees;
        }
        this.setState({render_list_employees: employees});
    }

    openSettings = () => modalManage.show('settingLamp');

    setTemplateLamp = (type_view = 'grid') => {
        let template = type_view === 'grid' ? 'grid' : 'list';
        lampManage.setTemplateLamp(template);
    }

    render() {
        return <Startup {...this.state} {...this.props}
                openSettings={this.openSettings}
                search={this.search}
                setTemplateLamp={this.setTemplateLamp}
                setSelectedStructures={this.setSelectedStructures} />
    }
}

const mapStateToProps = (store) => {
    return {
        load: store.loadState,
        lamp: store.lampState,
        app: store.appState,
    };
};

/**
 * @param message
 * @constructor
 */
const NotHasTabNum = (message) => {
    this.message = message;
    this.name = 'Not has tab num';
}

export default withRouter(connect(mapStateToProps)(withTranslation()(StartupContainer)));